<template>
    <div class="er-type-step">
        <div class="er-type-step-title">Выберите статью расхода</div>
        <div class="er-type-step-options">
            <div class="er-type-step-option er-card"
                 :class="{selected: expenditureRequest.expenditure_id === option.expenditure_id}"
                 v-for="option in options"
                 @click="updateExpenditureRequest({key: 'expenditure_id', data: option.expenditure_id})"
            >
                <div class="er-type-step-option-title">{{option.title}} <img :src="option.icon" alt=""></div>
                <div class="er-type-step-option-desc">{{option.description}}</div>
            </div>
        </div>
    </div>

</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
    name: "ExpenditureRequestTypeStep.vue",
    data(){
        return {
            options: [
                {
                    title: "Медицинские расходы",
                    description: "Расходы на услуги в ветеринарных клиниках.",
                    type: 'allotment_request',
                    expenditure_id: 4,
                    icon: '/assets/images/svg/medical.svg'
                },
                {
                    title: "Товары",
                    description: "Расходы на товары, в том числе ветеринарные.",
                    type: 'allotment_request',
                    expenditure_id: 3,
                    icon: '/assets/images/svg/shop.svg'

                },
                {
                    title: "Услуги по передержке",
                    description: "Расходы на гостиницы и индивидуальные передержки.",
                    type: 'allotment_request',
                    expenditure_id: 8,
                    icon: '/assets/images/svg/home.svg'
                },
/*                {
                    title: "Реклама",
                    description: "Расходы на рекламу платформы",
                    type: 'allotment_request',
                    expenditure_id: 7,
                    icon: '/assets/images/svg/dog.svg'
                },*/
                {
                    title: "Другое",
                    description: "Любые другие расходы.",
                    type: 'allotment_request',
                    expenditure_id: 5,
                    icon: '/assets/images/svg/bowl.svg'
                },
            ]
        }
    },
    computed: {
        ...mapGetters({
            expenditureRequest: 'getterExpenditureRequest'
        })
    },
    methods: {
        ...mapMutations({updateExpenditureRequest: 'setterExpenditureRequestParam'})
    }
}
</script>

<style lang="scss" scoped>
.er-type-step {
    &-title {
        font-weight: 700;
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        margin-bottom: 50px;
    }

    &-option {
        margin-bottom: 30px;
        cursor: pointer;



        &-title {
            font-weight: 700;
            font-size: 24px;
            line-height: 34px;

            img {
                margin-left: 40px;
            }
        }
        &-desc {
            margin-top: 30px;
            font-size: 14px;
            line-height: 20px;
            max-width: 620px;
        }
    }
}
</style>
